document.addEventListener("DOMContentLoaded", () => {
  console.warn("iniciou js.");
  const container = document.querySelector("#ambiente-options") || document.querySelector(".custom-selector .options");
  if (!container) {
    console.warn("Seletor de ambientes não encontrado.");
    return;
  }

  // Encontrar ou criar o hidden input que envia para o carrinho
  let hiddenInput = document.querySelector("#ambiente-hidden") || document.querySelector('input[name="properties[Ambiente]"]');
  if (hiddenInput) {
    console.warn("IF1.");
    const productForm = document.querySelector('.formulario-adicionar-carrinho');
    if (productForm) {
      hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = 'properties[Ambiente]';
      hiddenInput.id = 'ambiente-hidden';
      productForm.appendChild(hiddenInput);
      console.log("Formulário do produto encontrado.");

    } else {
      hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.id = 'ambiente-hidden';
      document.body.appendChild(hiddenInput);
      console.log("Formulário do produto não encontrado — hidden input criado no body (verifique).");
    }
  }else{
    console.warn("ELSE1.");
  }

  const addInput = document.querySelector("#new-ambiente") || container.querySelector('input.custom') || container.querySelector('input[type="text"]');
  const checkbox = document.querySelector("#dont-select-environment") || container.querySelector('input[type="checkbox"].checkbox') || container.querySelector('input[type="checkbox"]');

  let selecionado = "";

  function getValueFromBtn(btn) {
    return btn.dataset.value || btn.getAttribute('data-customization-autofill') || (btn.textContent || "").trim();
  }

  function updateHidden() {
    hiddenInput.value = selecionado;
  }

  function clearAllSelections() {
    container.querySelectorAll('.option').forEach(o => o.classList.remove('-selected'));
    if (checkbox) checkbox.checked = false;
    selecionado = "";
    updateHidden();
  }

  // Delegation: clique dentro do container
  container.addEventListener('click', (e) => {
    const target = e.target;

    // Remover (X)
    if (target.matches('.remove')) {
      const li = target.closest('li');
      const optionBtn = li ? li.querySelector('.option') : null;
      const val = optionBtn ? getValueFromBtn(optionBtn) : null;
      if (li) li.remove();
      if (val && val === selecionado) {
        selecionado = "";
        updateHidden();
      }
      return;
    }

    // Clicar em uma opção (botão)
    if (target.matches('.option')) {
      // Se for um input checkbox real, ignore aqui (o checkbox tem handler específico)
      if (target.tagName.toLowerCase() === 'input' && target.type === 'checkbox') return;

      // marca apenas essa opção
      container.querySelectorAll('.option').forEach(o => o.classList.remove('-selected'));
      if (checkbox) checkbox.checked = false;

      target.classList.add('-selected');
      selecionado = getValueFromBtn(target);
      updateHidden();
      return;
    }
  });

  // Checkbox: Prefiro não selecionar
  if (checkbox) {
    checkbox.addEventListener('change', () => {
      if (checkbox.checked) {
        container.querySelectorAll('.option').forEach(o => o.classList.remove('-selected'));
        selecionado = "Prefiro não selecionar o ambiente";
      } else {
        selecionado = "";
      }
      updateHidden();
    });
  }

  // Adicionar novo ambiente via Enter
  if (addInput) {
    addInput.addEventListener('keypress', (e) => {
      if (e.key === 'Enter' && addInput.value.trim() !== '') {
        e.preventDefault();
        const novo = addInput.value.trim();

        // Limpa seleções anteriores
        container.querySelectorAll('.option').forEach(o => o.classList.remove('-selected'));
        if (checkbox) checkbox.checked = false;

        // Cria <li> com botão e remove
        const li = document.createElement('li');
        li.className = 'item';

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'option -selected';
        btn.textContent = novo;
        btn.setAttribute('data-value', novo);

        const rem = document.createElement('button');
        rem.type = 'button';
        rem.className = 'remove';
        rem.textContent = '×';
        rem.title = `Remover a opção ${novo}`;

        li.appendChild(btn);
        li.appendChild(rem);

        const refLi = addInput.closest('li');
        if (refLi) refLi.before(li); else container.appendChild(li);

        selecionado = novo;
        updateHidden();
        addInput.value = '';
      }
    });
  }

  // Inicializar se já houver uma opção marcada no HTML
  const initial = container.querySelector('.option.-selected');
  if (initial) {
    selecionado = getValueFromBtn(initial);
    if (checkbox) checkbox.checked = false;
    updateHidden();
  }
});


document.addEventListener("DOMContentLoaded", () => {
  // Seleciona todos os itens do slider
  const items = document.querySelectorAll('.multicolumn-list__item');

  items.forEach(item => {
    const link = item.querySelector('a.link');

    // Se não houver link ou href vazio, esconde o li
    if (!link || !link.getAttribute('href') || link.getAttribute('href').trim() === "") {
      item.style.display = 'none';
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {

  // Encontrar ou criar o hidden input que envia para o carrinho
  let hiddenInput1 = document.querySelector("#base_deca_ou_docol-hidden");
  if (hiddenInput1) {
    const productForm1 = document.querySelector('.formulario-adicionar-carrinho');
    if (productForm1) {
      hiddenInput1 = document.createElement('input');
      hiddenInput1.type = 'hidden';
      hiddenInput1.name = 'properties[Base]';
      hiddenInput1.id = 'base-hidden';
      productForm1.appendChild(hiddenInput1);
      console.log("Formulário do produto encontrado.");

    } else {
      hiddenInput1 = document.createElement('input');
      hiddenInput1.type = 'hidden';
      hiddenInput1.id = 'ambiente-hidden';
      document.body.appendChild(hiddenInput1);
      console.log("Formulário do produto não encontrado — hidden input criado no body (verifique).");
    }
  }else{
    console.warn("ELSE1a.");
  }  

  document.querySelectorAll(".button-base").forEach(el => {
    el.addEventListener("click", function (e) {
      const target = e.target;

      // Remover classe ativos
      document.querySelectorAll(".button-base").forEach(el => {
        console.log('--oi2--');
        el.classList.remove("opcao-ativa");
      });
      target.classList.add("opcao-ativa");

      const valor = target.getAttribute('data-value');
      document.querySelector("#base_deca_ou_docol-hidden").value = valor;
      document.querySelector("#base-hidden").value = valor;
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {

  // Encontrar ou criar o hidden input que envia para o carrinho
  let hiddenInput2 = document.querySelector("#opcaocristal-hidden");
  if (hiddenInput2) {
    const productForm2 = document.querySelector('.formulario-adicionar-carrinho');
    if (productForm2) {
      hiddenInput2 = document.createElement('input');
      hiddenInput2.type = 'hidden';
      hiddenInput2.name = 'properties[Cristal]';
      hiddenInput2.id = 'cristal-hidden';
      productForm2.appendChild(hiddenInput2);
      console.log("Formulário do produto encontrado.");

    } else {
      hiddenInput2 = document.createElement('input');
      hiddenInput2.type = 'hidden';
      hiddenInput2.id = 'cristal-hidden';
      document.body.appendChild(hiddenInput2);
      console.log("Formulário do produto não encontrado — hidden input criado no body (verifique).");
    }
  }else{
    console.warn("ELSE2.");
  }

  document.querySelectorAll(".button-cristal").forEach(el => {
    el.addEventListener("click", function (e) {
      const target = e.target;

      // Remover classe ativos
      document.querySelectorAll(".button-cristal").forEach(el => {
        console.log('--oi2--');
        el.classList.remove("opcao-ativa");
      });
      target.classList.add("opcao-ativa");

      const valor = target.getAttribute('data-value');
      document.querySelector("#opcaocristal-hidden").value = valor;
      document.querySelector("#cristal-hidden").value = valor;
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {

  // Encontrar ou criar o hidden input que envia para o carrinho
  let hiddenInput2 = document.querySelector("#opcaofuros-hidden");
  if (hiddenInput2) {
    const productForm2 = document.querySelector('.formulario-adicionar-carrinho');
    if (productForm2) {
      hiddenInput2 = document.createElement('input');
      hiddenInput2.type = 'hidden';
      hiddenInput2.name = 'properties[Furos]';
      hiddenInput2.id = 'furos-hidden';
      productForm2.appendChild(hiddenInput2);
      console.log("Formulário do produto encontrado.");

    } else {
      hiddenInput2 = document.createElement('input');
      hiddenInput2.type = 'hidden';
      hiddenInput2.id = 'furos-hidden';
      document.body.appendChild(hiddenInput2);
      console.log("Formulário do produto não encontrado — hidden input criado no body (verifique).");
    }
  }else{
    console.warn("ELSE2.");
  }

  document.querySelectorAll(".button-furos").forEach(el => {
    el.addEventListener("click", function (e) {
      const target = e.target;

      // Remover classe ativos
      document.querySelectorAll(".button-furos").forEach(el => {
        console.log('--oi2--');
        el.classList.remove("opcao-ativa");
      });
      target.classList.add("opcao-ativa");

      const valor = target.getAttribute('data-value');
      document.querySelector("#opcaofuros-hidden").value = valor;
      document.querySelector("#furos-hidden").value = valor;
    });
  });
});